import { Box, Grid, Typography } from "@mui/material";
import {
	ExtensionNumberRHF,
	PhoneNumberRHF,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface IPADAgreenmentAccountDetailsPanel {
	accountantBankDetailsForPADData: any
}
export const PADAgreenmentAccountDetailsPanel: FC<
	IPADAgreenmentAccountDetailsPanel
> = ({ accountantBankDetailsForPADData }) => {
	return (
		// <Box sx={{ textAlign: "right" }}>
		// 	<Typography sx={{ fontSize: ".875rem" }}>abc</Typography>
		// 	<Typography sx={{ fontSize: ".875rem" }}>123</Typography>
		// 	<Typography sx={{ fontSize: ".875rem" }}>Toronto, ON, A2A2A2</Typography>
		// 	<Typography sx={{ fontSize: ".875rem" }}>1234567890</Typography>
		// </Box>
		<div style={{ fontSize: "0.875rem", textAlign: "right" }}>
			<Typography sx={{ fontSize: ".875rem" }}>{accountantBankDetailsForPADData && accountantBankDetailsForPADData.accTitle}</Typography>
			<Typography sx={{ fontSize: ".875rem" }}>{accountantBankDetailsForPADData && accountantBankDetailsForPADData.address}</Typography>
			<Typography sx={{ fontSize: ".875rem" }}>{accountantBankDetailsForPADData && accountantBankDetailsForPADData.city}{accountantBankDetailsForPADData && accountantBankDetailsForPADData.city && ","} {accountantBankDetailsForPADData && accountantBankDetailsForPADData.shortCode}{accountantBankDetailsForPADData && accountantBankDetailsForPADData.shortCode && ","} {accountantBankDetailsForPADData && accountantBankDetailsForPADData.postCode}</Typography>
			<Typography sx={{ fontSize: ".875rem" }}>{accountantBankDetailsForPADData && accountantBankDetailsForPADData.phone}</Typography>
		</div>
	);
};
